module.exports = __webpack_public_path__ + "static/media/6-8-inhwal2.db89463f.jpg";